import { PropTypes } from 'prop-types';
import React from 'react';

import { COLORS } from '../../constants/colors';

const PlayButton = ({
  background = COLORS.snow,
  color = COLORS.liquorice,
  isPlaying = false,
}) => {
  return (
    <svg fill="none" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
      <circle cx="30" cy="30" fill={background} r="30" />
      {isPlaying ? (
        <g>
          <rect fill={color} height="24" width="7" x="20" y="18" />
          <rect fill={color} height="24" width="7" x="33" y="18" />
        </g>
      ) : (
        <path
          d="M22.4117 42.0864L22.4117 17.818L43.4287 29.9522L22.4117 42.0864Z"
          fill={color}
        />
      )}
    </svg>
  );
};

PlayButton.propTypes = {
  background: PropTypes.string,
  color: PropTypes.string,
  isPlaying: PropTypes.bool,
};

export default PlayButton;
